<template>
  <div class="AddSmartCurtainWidget lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddSmartCurtainWidget-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddSmartCurtainWidget-main lxn-pos-rel">
      <div class="AddSmartCurtainWidget-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSmartCurtainWidget_title1}}
          </template>
          <template v-slot:body>
            <div class="AddSmartCurtainWidget-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="AddSmartCurtainWidget-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="AddSmartCurtainWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="AddSmartCurtainWidget-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="AddSmartCurtainWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="AddSmartCurtainWidget-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="AddSmartCurtainWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="AddSmartCurtainWidget-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="AddSmartCurtainWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="AddSmartCurtainWidget-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="AddSmartCurtainWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="AddSmartCurtainWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="WidgetName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddSmartCurtainWidget_namePlaceHolder" inputType="text" />
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSmartCurtainWidget_title2}}
          </template>
          <template v-slot:body>
            <div class="AddSmartCurtainWidget-wrapper-field-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_text2}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="curtainType" :dropDownContex="dropDownCurtainType" />
            </div>
            <div class="AddSmartCurtainWidget-wrapper-field-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_text3}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetHub" :dropDownContex="dropDownTargetHub" />
            </div>
          </template>
        </TitleBox>
        <TitleBox v-if="curtainType == 0" titleBgColor="#00AEEF" bgColor="#afd6e5">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSmartCurtainWidget_commands}}
          </template>
          <template v-slot:body>
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_up_description}}
            </div>
            <CommandCreator :key="1" v-model="generatedCommand_curtain_up" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" />
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_stop_description}}
            </div>
            <CommandCreator :key="2" v-model="generatedCommand_curtain_stop" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" />
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_down_description}}
            </div>
            <CommandCreator :key="3" v-model="generatedCommand_curtain_down" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" />
          </template>
        </TitleBox>
        <TitleBox v-else titleBgColor="#00AEEF" bgColor="#afd6e5">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSmartCurtainWidget_commands}}
          </template>
          <template v-slot:body>
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_left_description}}
            </div>
            <CommandCreator :key="4" v-model="generatedCommand_curtain_left" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" />
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_stop_description}}
            </div>
            <CommandCreator :key="5" v-model="generatedCommand_curtain_stop" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" />
            <div class="AddSmartCurtainWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSmartCurtainWidget_right_description}}
            </div>
            <CommandCreator :key="6" v-model="generatedCommand_curtain_right" titleBgColor="#00AEEF" :multiHub="true" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" />
          </template>
        </TitleBox>
      </div>
      <div class="AddSmartCurtainWidget-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddSmartCurtainWidget_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CommandCreator from '@/components/CommandCreator.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'

export default {
  name: 'AddSmartCurtainWidget',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    CommandCreator,
    DropDown
  },
  data: function () {
    return {
      WidgetName: '',
      input1State: '',
      activeBoxIndex: 0,
      curtainType: 0,
      targetHub: 0,
      generatedCommand_curtain_up: [],
      generatedCommand_curtain_stop: [],
      generatedCommand_curtain_down: [],
      generatedCommand_curtain_left: [],
      generatedCommand_curtain_right: [],
    }
  },
  mounted: function () {
  },
  watch: {
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    dropDownCurtainType: function () {
      return {
        name: "AddSmartCurtainWidget-curtainType",
        title: this.$store.getters.language.texts.AddSmartCurtainWidget_text2,
        selectedIndex: this.curtainType,
        data: [
          {
            name: this.$store.getters.language.texts.AddSmartCurtainWidget_curtainType1,
            icon: 'upDownCurtain',
          },
          {
            name: this.$store.getters.language.texts.AddSmartCurtainWidget_curtainType2,
            icon: 'leftRightCurtain',
          },
        ]
      }
    },
    dropDownTargetHub: function () {
      var dropDownTargetHub = {
        name: "AddSmartCurtainWidget-TargetHubs",
        title: this.$store.getters.language.texts.AddSmartCurtainWidget_text5,
        selectedIndex: this.targetHub,
        data: []
      };
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        dropDownTargetHub.data.push({
          name: this.$store.state.hubs[i].name,
          icon: "hub",
        })
      }
      return dropDownTargetHub;
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.WidgetName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.WidgetName_alert);
      }else if(this.curtainType == 0 && this.generatedCommand_curtain_up.length == 0){
        alert(this.$store.getters.language.texts.AddSmartCurtainWidget_alertCurtainUpNoCommand);
      }else if(this.curtainType == 0 && this.generatedCommand_curtain_down.length == 0){
        alert(this.$store.getters.language.texts.AddSmartCurtainWidget_alertCurtainDownNoCommand);
      }else if(this.curtainType == 1 && this.generatedCommand_curtain_left.length == 0){
        alert(this.$store.getters.language.texts.AddSmartCurtainWidget_alertCurtainLeftNoCommand);
      }else if(this.automationType == 1 && this.generatedCommand_curtain_right.length == 0){
        alert(this.$store.getters.language.texts.AddSmartCurtainWidget_alertCurtainRightNoCommand);
      }else if(this.generatedCommand_curtain_stop.length == 0){
        alert(this.$store.getters.language.texts.AddSmartCurtainWidget_alertCurtainStopNoCommand);
      }else{
        this.$store.commit('setAppBusy', true);
        var hubUUID = this.$store.state.hubs[this.targetHub].uuid;
        this.$store.commit('addWidget', {
          name: this.WidgetName,
          color: this.activeBoxIndex,
          type: "smartCurtainWidget",
          hubUUID: hubUUID,
          visible: true,
          path: this.$store.state.activeDashboardFolderId,
          settings: {
            curtainType: this.curtainType,
            curtainUpCommand: this.generatedCommand_curtain_up,
            curtainDownCommand: this.generatedCommand_curtain_down,
            curtainLeftCommand: this.generatedCommand_curtain_left,
            curtainRightCommand: this.generatedCommand_curtain_right,
            curtainStopCommand: this.generatedCommand_curtain_stop,
          }
        });
        this.$store.commit('saveState');
        this.$router.push('/home/dashboard/');
        this.$store.commit('setAppBusy', false);
      }
    },
  }
}
</script>

<style>
  .AddSmartCurtainWidget-topCurve-wrapper {
    height: 200px;
  }
  .AddSmartCurtainWidget-main {
    z-index: 2;
  }
  .AddSmartCurtainWidget-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .AddSmartCurtainWidget-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .AddSmartCurtainWidget-wrapper-colors {
    height: 50px;
  }
  .AddSmartCurtainWidget-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .AddSmartCurtainWidget-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .AddSmartCurtainWidget-color.active .AddSmartCurtainWidget-selectedColor {
    opacity: 1;
  }
  .AddSmartCurtainWidget-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .AddSmartCurtainWidget-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .AddSmartCurtainWidget-wrapper-name-text:first-child {
    height: 30px;
    padding-top: 0;
  }
  .AddSmartCurtainWidget-wrapper-field-text {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .AddSmartCurtainWidget-description {
    margin-top: 14px;
    margin-bottom: 14px;
  }
 .AddSmartCurtainWidget-description:first-child {
    margin-top: 0;
  }
</style>
